import { render, staticRenderFns } from "./AdminBbsInfo.vue?vue&type=template&id=24470fc8&"
import script from "./AdminBbsInfo.vue?vue&type=script&lang=js&"
export * from "./AdminBbsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminBbsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports